import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import Footer from '../Footer/Footer';
import ShopResume from './ShopResume/ShopResume';
import './ResumePage.scss';
import { useStateValue } from '../utilities/StateProvider';

export default function ResumePage() {

    const [ _ , dispatch] = useStateValue();

    const isOfAge = sessionStorage.getItem('ofAge');

    useEffect(() => {
        const savedCart = JSON.parse(sessionStorage.getItem('cart'));
        const savedUser = JSON.parse(sessionStorage.getItem('user'));
        const savedEvent = JSON.parse(sessionStorage.getItem('event'));

        if (savedCart) {
            dispatch({
                type: 'setCart',
                cart: savedCart
            });
        }
        if (savedUser) {
            dispatch({
                type: 'setUser',
                user: savedUser
            });
        }
        if (savedEvent) {
            dispatch({
                type: 'setEvent',
                event: savedEvent
            });
        }
    }, []);

    if (!isOfAge) {
        return (
            <Redirect to={{pathname: "/warning"}} />
        )
    }

    return (
        <div className="resume-page">
            <ShopResume />
            <Footer sticky="bottom" page="shop"/>
        </div>
    )
}
